import { EABError } from 'core-js-error';

angular.module('data-ng-personal-reminders', ['data-ng-path-item']);

require('./commands/create_reminder_command');
require('./commands/delete_reminder_command');
require('./commands/edit_reminder_command');
require('./commands/load_reminder_command');
require('./commands/load_all_reminder_command');
require('./commands/load_all_reminder_date_range_command');

require('./components/expanding_reminder_textbox/expanding_reminder_textbox_controller');
require('./components/expanding_reminder_textbox/expanding_textbox_directive');

require('./datasources/create_reminder_datasource');
require('./datasources/personal_reminder_list_datasource');

require('./services/personal_reminder_service');
require('./services/reminder_filter_servant');

import './queries/reminder_queries_module';

export * from './datasources/create_reminder_datasource';
export * from './datasources/personal_reminder_list_datasource';
export * from './personal_reminder_interface';
export * from './services/personal_reminder_service';
export * from './services/reminder_filter_servant';
export * from './queries/reminder_query';
export * from './queries/reminder_list_query';
export * from './queries/reminder_priority_feed_query';



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/main.ts